export const nav = 1;

export default {
  ["usergroup-list"]: {
    nav,
    icon: "shield",
    url: "/auth/usergroup-list",
    title: "User Groups",
    templateProvider: $stateParams => `<usergroup-list />`
  },
  ["usergroup"]: {
    nav,
    icon: "shield",
    url: "/auth/usergroup",
    title: "User Group",
    templateProvider: $stateParams => `<usergroup-edit />`
  },
  ['usergroup']: {
    url: '/auth/usergroup/{usergroupId:[^/]+}',
    title: 'User Group Edit',
    templateProvider: ($stateParams) => `<usergroup-edit usergroup-id="${$stateParams.usergroupId}"/>` // <ui-view/>
  }
};
